import React from "react";

const CardCatalogoList = ({
    producto,
    onVerDetallesClick,
    onAgregarClick,
    onCotizarClick,
}) => {
    const { id, imagenes = [], nombre, descripcion, precio } = producto;

    return (
        <div className="col-12 mb-3">
            <div className="card d-flex flex-row align-items-center shadow-sm border-0 rounded-lg p-3">
                {/* Imagen del producto */}
                <div className="me-3" style={{ width: "100px", height: "100px" }}>
                    {imagenes.length > 0 ? (
                        <img
                            src={imagenes[0]}
                            className="img-fluid rounded"
                            alt={nombre}
                            style={{ objectFit: "cover", width: "100%", height: "100%" }}
                        />
                    ) : (
                        <img
                            src="/productos.jpg"
                            className="img-fluid rounded"
                            alt={nombre}
                            style={{ objectFit: "cover", width: "100%", height: "100%" }}
                        />
                    )}
                </div>

                {/* Detalles del producto */}
                <div className="flex-grow-1 mx-2">
                    <h5 className="mb-1">{nombre}</h5>
                    <p className="text-muted small mb-2">{descripcion || "Sin descripción"}</p>
                    <span className="fw-bold fs-5">L {precio}</span>
                </div>

                {/* Botones de acción */}
                <div className="d-flex flex-column ms-auto gap-2">
                    <button
                        onClick={() => onVerDetallesClick(producto)}
                        className="btn btn-light text-dark fw-bold rounded-pill"
                    >
                        <i className="fas fa-eye me-1"></i> Ver más
                    </button>
                    <button
                        onClick={() => onAgregarClick(producto)}
                        className="btn btn-dark text-white fw-bold rounded-pill my-2"
                    >
                        <i className="fas fa-cart-plus me-1"></i> Agregar
                    </button>
                    {onCotizarClick && (
                        <button
                            onClick={() => onCotizarClick(producto)}
                            className="btn btn-primary fw-bold rounded-pill"
                        >
                            <i className="fas fa-file-invoice me-1"></i> Cotizar
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CardCatalogoList;